import React, { useEffect, useState } from 'react';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <div className={className} data-id="element-309">{children}</div>;
export const Button = ({
  href,
  children,
  variant = 'primary',
  className = ''
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-6 md:px-10 py-5 rounded-full font-sans font-black transition-all duration-500 transform hover:scale-105 active:scale-95 shadow-2xl text-center leading-tight tracking-tight uppercase';
  const variants = {
    primary: 'bg-gradient-to-r from-premium-gold via-premium-gold-luminous to-premium-gold-dark text-navy-950 hover:shadow-[0_0_50px_rgba(255,215,0,0.4)] relative overflow-hidden group border-b-4 border-premium-gold-dark/50',
    secondary: 'bg-navy-800 text-white border border-white/20 hover:bg-navy-700 hover:border-premium-gold/50 backdrop-blur-md'
  };
  return <a href={href} className={`${baseStyle} ${variants[variant]} ${className}`} data-id="element-310">
      {variant === 'primary' && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-311" />}
      <span className="relative z-10" data-id="element-312">{children}</span>
    </a>;
};
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 16,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-313">
      <div className="relative bg-navy-950 px-4 md:px-6 py-4 md:py-5 rounded-2xl border border-red-500/30 shadow-[0_10px_40px_rgba(0,0,0,0.5)] min-w-[70px] md:min-w-[90px] overflow-hidden group" data-id="element-314">
        {/* Subtle top highlight */}
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-400/50 to-transparent" data-id="element-315" />
        <div className="absolute inset-0 bg-red-500/5 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-316"></div>

        <div className="relative flex justify-center items-center h-10 md:h-14" data-id="element-317">
          <span className="text-4xl md:text-6xl font-mono font-black text-red-500 tracking-tighter drop-shadow-[0_0_15px_rgba(239,68,68,0.4)]" data-id="element-318">
            {format(value)}
          </span>
        </div>
      </div>
      <span className="text-[10px] md:text-[12px] text-gray-300 uppercase font-black tracking-[0.2em] mt-4 opacity-80" data-id="element-319">
        {label}
      </span>
    </div>;
  return <div className="flex items-start justify-center space-x-2 md:space-x-4" data-id="element-320">
      <TimeUnit value={timeLeft.hours} label="horas" data-id="element-321" />
      <div className="text-red-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-322">
        :
      </div>
      <TimeUnit value={timeLeft.minutes} label="minutos" data-id="element-323" />
      <div className="text-red-500/40 text-2xl md:text-4xl font-light pt-3 md:pt-5 animate-pulse" data-id="element-324">
        :
      </div>
      <TimeUnit value={timeLeft.seconds} label="segundos" data-id="element-325" />
    </div>;
};